import { createFileRoute } from "@tanstack/react-router";
import { ShowroomPage, showroomHeadDa } from "@/pages/ShowroomPage";

export const Route = createFileRoute("/showroom")({
  head: showroomHeadDa,
  component: ShowroomPage,
});
